import { useHandbook } from 'components/Handbook2_0/hooks'

export const useHandbookReadOnlyUser = () => {
  const handbook = useHandbook()

  const isReadOnlyUser = !['edit', 'owner'].includes(handbook?.current_user_access || 'none')
  return {
    isReadOnlyUser,
  }
}
